import upsell from "../upsell"
import apiDietPaymentProcessor from "../apiDietPaymentProcessor"
import { TrackingManager } from "../../../../../lib/common/js/services/tracking/trackingManager"
import { ensureTrailingSlash } from "../helpers"

const DEFAULT_NUTRITIONIST = "elina"
const NO_NUTRIONIST = "no_coach"

export default (getView) => (nextStepPath, successStepPath, failedStepPath) => ({
  ...getView(nextStepPath),
  ...upsell("chat"),

  isPaymodeModalNeeded: false,
  isPaymodeModalOpen: false,
  activeNutrionist: DEFAULT_NUTRITIONIST,
  internalTracker: new TrackingManager(
    window.trackingConfig.enabledTrackingServices,
    pipelineConfig
  ),

  saveSelectedNutrionistInStore(nutrionist) {
    this.store.values.selectedChatNutrionist = nutrionist
  },

  init() {
    this.saveSelectedNutrionistInStore(DEFAULT_NUTRITIONIST)
    this.commonInit()

    if (
      !this.store.values.lastPaymentMethod ||
      this.store.values.lastPaymentMethod !== "primer" ||
      !this.store.values.isCardSaved
    ) {
      this.isPaymodeModalNeeded = true
    }
  },

  handleNutrionistChange(nutrionist) {
    this.internalTracker.trackClick({ clickName: "Expert Selected" })
    this.activeNutrionist = nutrionist
    this.saveSelectedNutrionistInStore(nutrionist)
  },

  async handlePayment(paymode) {
    if (this.activeNutrionist === NO_NUTRIONIST) {
      const nextStepLink = ensureTrailingSlash(`${pipelineConfig.pathPrefix}${
        pipelineConfig.variants[pipelineConfig.variant].pagePaths["chat-last-chance"]
      }#stored-token=${this.store.values.token}`)
      window.location = nextStepLink

      return
    }
    const { handleCheckoutAndRedirect } = apiDietPaymentProcessor

    // Handle card-save payments
    if (!paymode && !this.isPaymodeModalNeeded) {
      this.loading = true
      const paymentParamsCardSave = {
        successStepPath,
        failedStepPath,
        paymentMethod: "primer",
        restrictCardSave: false,
        checkoutTemplate: "cf-ac-pipe",
      }

      this.internalTracker.trackClick({ clickName: "Chat Accepted Clicked" })
      handleCheckoutAndRedirect(paymentParamsCardSave)
      return
    }
    // Open up modal if there is no paymode
    if (!paymode && this.isPaymodeModalNeeded) {
      this.isPaymodeModalOpen = true
      this.internalTracker.trackClick({ clickName: "Chat Accepted Clicked" })

      return
    }

    const trackingEventNames = {
      primer: "Credit Card Submitted",
      google_pay: "Google Pay Selected",
      apple_pay: "Apple Pay Selected",
      paypal_recurring: "PayPal Selected",
    }
    this.internalTracker.trackClick({ clickName: trackingEventNames[paymode] || paymode })

    // Handle payments that doesn't have save-card
    this.store.values.lastPaymentMethod = paymode
    this.loading = true
    const paymentParamsWithoutCardSave = {
      successStepPath,
      failedStepPath,
      paymentMethod: paymode,
      restrictCardSave: true,
      checkoutTemplate: "cf-ac-pipe",
    }

    handleCheckoutAndRedirect(paymentParamsWithoutCardSave)
  },

  async handleDecline() {
    this.internalTracker.trackClick({ clickName: "Chat Rejected Clicked" })
    const nextStepLink = ensureTrailingSlash(
      `${pipelineConfig.pathPrefix}${
        pipelineConfig.variants[pipelineConfig.variant].pagePaths["chat-last-chance"]
      }#stored-token=${this.store.values.token}`
    )
    window.location = nextStepLink

    return
  },

  onInit() {
    this.initUpsell()
  },

  handleModalClose() {
    this.internalTracker.trackClick({ clickName: "Close Modal Clicked" })
    this.isPaymodeModalOpen = false
  },
})
